import { EMAIL_STATISTICS_API } from 'modules/mailing/email-statistics/api/email-statistics-api'
import { EmailPreviewInterface } from 'modules/mailing/email-statistics/types/email-preview-interface'
import { EmailId } from 'shared/components/dashboard-mail-editor/types/email-interface'
import { RequestModuleEnum } from 'shared/enums/request-module-enum'
import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'

interface useEmailPreviewProps {
  emailId: EmailId
}

export function useEmailPreview({ emailId }: useEmailPreviewProps) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, EmailPreviewInterface>({
    method: RequestMethodsEnum.get,
  })

  const { data: emailPreviewData } = useControlledSwr(
    () => [`${EMAIL_STATISTICS_API}/${emailId}/preview`, RequestModuleEnum.CampaignStep],
    url => fetcher(url),
    undefined,
    !!user,
  )

  return {
    emailPreviewData,
  }
}
